import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useStore();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/admin");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser({ ...data, email: data.email });
        localStorage.setItem("pw_has_session", "1");
        window.history.replaceState(null, "", "/admin/dashboard");
        navigate("/admin/dashboard", { state: { user: data } });
      } catch {
        navigate("/admin");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0A0A0A]">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#E31E24] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/50 uppercase tracking-[0.2em] text-xs">Signing you in…</p>
      </div>
    </div>
  );
}
